import { css } from '@/styled-system/css';

export const feedCard = css({
  height: 'calc(100% - 16px)',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  borderRadius: '12px',
  overflow: 'hidden',
  backgroundColor: 'hpxBlack',
  marginX: '1x',
  marginTop: '1x',
  marginBottom: '1x',

  md: {
    height: '100%',
    marginX: 0,
    marginTop: 0,
    marginBottom: 0,
  },
});

export const rightActions = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
  flexShrink: 0,
  alignItems: 'center',
  width: '54px',
  marginRight: '-12px',
});

export const actionWrapper = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const actionLabel = css({
  color: 'hpxWhite',
  fontSize: 'md',
  fontWeight: 'bold',
  marginTop: 'xs',
});

export const actionButton = css({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  backgroundColor: 'hpxWhite',
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  fontSize: 'md',
  color: 'hpxTeal500',
  padding: 0,
  _focus: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const saveButton = css({
  width: '54px',
  height: '54px',
  borderRadius: '50%',
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  padding: 0,
  '& svg': {
    width: '28px',
    height: '28px',
  },
  _focus: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const saveButtonUnsaved = css({
  backgroundColor: 'hpxRed100',
  color: 'hpxRed400',
});

export const saveButtonSaved = css({
  backgroundColor: 'hpxRed100',
  color: 'hpxRed400',
});

export const imageContainer = css({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  backgroundColor: 'hpxGrey100',
  position: 'relative',
  userSelect: 'none',
  md: {
    '&:hover button[data-carousel-arrow]': {
      opacity: 1,
    },
    '&:hover button[data-carousel-arrow]:disabled': {
      opacity: 0.3,
    },
    _focusWithin: {
      '& button[data-carousel-arrow]': {
        opacity: 1,
      },
      '& button[data-carousel-arrow]:disabled': {
        opacity: 0.3,
      },
    },
  },
});

export const imageLoaded = css({
  opacity: 1,
});

export const imagePanning = css({
  animation: 'slowPanning',
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
});

export const bottomOverlay = css({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundImage: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0) 100%)',
  color: 'hpxWhite',
  paddingTop: '80px',
  paddingX: '3x',
  paddingBottom: '2x',
  pointerEvents: 'none',
  display: 'flex',
  flexDirection: 'column',
});

// A3: Re-enable pointer events on interactive children inside the overlay
export const bottomColumns = css({
  display: 'flex',
  gap: '1x',
  alignItems: 'flex-end',
  pointerEvents: 'auto',
});

export const bottomLeftColumn = css({
  flex: 1,
  minWidth: 0,
});

export const propertyName = css({
  fontSize: 'lg',
  fontWeight: 'bold',
  color: 'hpxWhite',
  lineHeight: '1.2',
  marginBottom: '2px',
});

export const listingType = css({
  fontSize: 'sm',
  color: 'hpxWhite',
  opacity: 0.9,
  marginBottom: '1x',
});

export const priceContainer = css({
  marginBottom: '1x',
});

export const priceDisplay = css({
  fontSize: '28px',
  fontWeight: 'bold',
  marginBottom: 'xs',
  lineHeight: '1.2',
});

export const priceCheck = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  fontSize: 'sm',
  fontWeight: 'bold',
  opacity: 0.9,
});

export const checkIcon = css({
  display: 'flex',
  flexShrink: 0,
});

export const detailsText = css({
  fontSize: 'sm',
  opacity: 0.9,
  marginBottom: '2x',
});

export const expandButton = css({
  backgroundColor: 'rgba(0, 0, 0, 0.25)',
  border: 'none',
  color: 'hpxWhite',
  height: '28px',
  width: '100%',
  borderRadius: '12px',
  fontSize: 'sm',
  fontWeight: '600',
  lineHeight: '1',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1x',
  textDecoration: 'none',
  marginTop: '1x',
  transitionProperty: 'background-color',
  transitionDuration: '0.2s',
  _hover: {
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
});

export const miniMapTrigger = css({
  position: 'absolute',
  top: '32px',
  right: '12px',
  zIndex: 'zIndexOverParent',
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
  width: '54px',
  height: '54px',
  '& > div': {
    width: '100%',
    height: '100%',
  },
});

export const carouselTrack = css({
  display: 'flex',
  width: '100%',
  minWidth: 0,
  height: '100%',
  overflowX: 'auto',
  scrollSnapType: 'x mandatory',
  overscrollBehavior: 'contain',
  scrollbarWidth: 'none',
  touchAction: 'pan-x',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const carouselSlide = css({
  flexShrink: 0,
  width: '100%',
  height: '100%',
  scrollSnapAlign: 'start',
});

export const carouselImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  pointerEvents: 'none',
  userSelect: 'none',
});

export const paginationContainer = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.60)',
  borderRadius: '12px',
  paddingX: '6px',
  paddingY: '4px',
  alignSelf: 'center',
  marginTop: '1x',
  overflow: 'hidden',
});

export const paginationDot = css({
  borderRadius: '50%',
  backgroundColor: '#6E6E6E',
  flexShrink: 0,
  transitionProperty: 'width, height, background-color, opacity, margin',
  transitionDuration: '0.3s',
  transitionTimingFunction: 'ease-out',
});

export const arrowButton = css({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'rgba(255, 255, 255, 0.9)',
  border: 'none',
  borderRadius: '50%',
  width: '36px',
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  zIndex: 'zIndexParent',
  opacity: 0,
  transitionProperty: 'opacity',
  transitionDuration: '0.2s',
  pointerEvents: 'auto',
  color: 'hpxBlue600',
  _disabled: {
    cursor: 'not-allowed',
  },
  _focus: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const arrowButtonPrev = css({
  left: '12px',
});

export const arrowButtonNext = css({
  right: '12px',
});

export const srOnly = css({
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  borderWidth: 0,
});

export const skeletonPhoto = css({
  width: '100%',
  height: '100%',
  animation: 'shimmering',
  bgGradient: 'heroPhotoContainerBgGradient',
  backgroundSize: '200% 100%',
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
});

export const skeletonBar = css({
  height: '14px',
  borderRadius: '4px',
  bg: 'rgba(255, 255, 255, 0.15)',
});

export const skeletonCircle = css({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  bg: 'rgba(255, 255, 255, 0.15)',
});
